
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   Box,
//   Typography,
//   IconButton,
//   Modal,
//   Divider,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import CloseIcon from "@mui/icons-material/Close";
// import FacebookIcon from '@mui/icons-material/Facebook';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import InstagramIcon from '@mui/icons-material/Instagram';
// import Classes from "./footer.module.css";
// import { useTranslation } from "react-i18next";
// import { API_BASE_URL } from "../../config";

// const modalStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: { xs: "90vw", sm: 400 },
//   bgcolor: "background.paper",
//   boxShadow: 24,
//   p: 3,
//   borderRadius: 3,
//   outline: "none",
// };

// export const FooterBar = () => {
//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
//   const { t } = useTranslation();

//   // Modal state
//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState({ title: "", description: "" });

//   // Visitors count state
//   const [visitorsCount, setVisitorsCount] = useState(null);

//   // Get policies from translation
//   const policies = t("policies", { returnObjects: true });

//   // Fetch visitors count from API on component mount
//   useEffect(() => {
//     const fetchVisitorsCount = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/auth/visitors/`);
//         if (response.data && typeof response.data.visitors_count === "number") {
//           setVisitorsCount(response.data.visitors_count);
//         }
//       } catch (error) {
//         console.error("Failed to fetch visitors count:", error);
//       }
//     };
//     fetchVisitorsCount();
//   }, []);

//   const openModal = (title, description) => {
//     setModalContent({ title, description });
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//   };

//   // Split policies into 4 roughly equal columns for desktop
//   const chunkSize = Math.ceil(policies.length / 4);
//   const policyColumns = [];
//   for (let i = 0; i < policies.length; i += chunkSize) {
//     policyColumns.push(policies.slice(i, i + chunkSize));
//   }

//   return (
//     <Box component="footer" sx={{ width: "100%", bgcolor: "rgb(175, 213, 235)", mt: 0.5, mb: 1 }}>
//       {/* First Footer Row */}
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: { xs: "column", md: "row" },
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//           gap: { xs: 4, md: 2 },
//           maxWidth: 1200,
//           mx: "auto",
//           px: 2,
//           py: 2,
//           position: 'relative',
//         }}
//       >
//         {/* 1. Disclaimer */}
//         <Box sx={{ flex: 1, minWidth: 280 }}>
//           <Typography variant="h6" gutterBottom fontWeight="bold">
//             {t("disclaimerTitle")}
//           </Typography>
//           <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
//             {t("disclaimerText")}
//           </Typography>
//         </Box>

//         {/* 2. Website Policies */}
//         <Box sx={{ flex: 2, minWidth: 280 }}>
//           <Typography variant="h6" gutterBottom fontWeight="bold">
//             {t("websitePolicies")}
//           </Typography>
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: { xs: "column", md: "row" },
//               gap: 1,
//             }}
//           >
//             {policyColumns.map((column, colIndex) => (
//               <Box key={colIndex} sx={{ flex: 1 }}>
//                 {column.map((policy) => (
//                   <Box
//                     key={policy.title}
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       py: 0.8,
//                       borderBottom: "1px solid rgba(0,0,0,0.1)",
//                       cursor: "pointer",
//                       "&:hover": { bgcolor: "rgba(0,0,0,0.04)" },
//                     }}
//                     onClick={() => openModal(policy.title, policy.description)}
//                     role="button"
//                     tabIndex={0}
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter" || e.key === " ") {
//                         openModal(policy.title, policy.description);
//                       }
//                     }}
//                     aria-label={`Open ${policy.title} details`}
//                   >
//                     <Typography variant="body2">{policy.title}</Typography>
//                     <ChevronRightIcon fontSize="small" />
//                   </Box>
//                 ))}
//               </Box>
//             ))}
//           </Box>
//         </Box>

//         {/* 3. Visitors */}
//         <Box sx={{ flex: 1, minWidth: 280 }}>
//           <Typography variant="h6" gutterBottom fontWeight="bold">
//             {t("visitors")}
//           </Typography>
//           <Typography variant="body2" mb={0.5}>
//             {t("latestUpdate")}
//           </Typography>
//           <Typography variant="body2" mb={0.5}>
//             {t("visitorsCount")} : {visitorsCount !== null ? visitorsCount : "Loading..."}
//           </Typography>
//           <Typography variant="body2">{t("version")}</Typography>
//         </Box>

//         {/* Social Media Icons at center end */}
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             width: { xs: '100%', md: 300 },
//             position: { md: 'absolute' },
//             left: { md: '50%' },
//             bottom: { md: -20 },
//             transform: { md: 'translateX(-50%)' },
//             mt: { xs: 3, md: 0 },
//             zIndex: 1,
//             gap: 1,
//           }}
//         >
//           <IconButton
//             component="a"
//             href="https://facebook.com"
//             target="_blank"
//             rel="noopener"
//             aria-label="Facebook"
//             color="primary"
//           >
//             <FacebookIcon />
//           </IconButton>
//           <IconButton
//             component="a"
//             href="https://twitter.com"
//             target="_blank"
//             rel="noopener"
//             aria-label="Twitter"
//             color="primary"
//           >
//             <TwitterIcon />
//           </IconButton>
//           <IconButton
//             component="a"
//             href="https://linkedin.com"
//             target="_blank"
//             rel="noopener"
//             aria-label="LinkedIn"
//             color="primary"
//           >
//             <LinkedInIcon />
//           </IconButton>
//           <IconButton
//             component="a"
//             href="https://instagram.com"
//             target="_blank"
//             rel="noopener"
//             aria-label="Instagram"
//             color="primary"
//           >
//             <InstagramIcon />
//           </IconButton>
//         </Box>
//       </Box>

//       {/* Second Footer Row */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           py: 1,
//           bgcolor: "rgb(139, 203, 240)",
//           mt: 3,
//         }}
//         className={Classes.footerBottom}
//       >
//         <Typography variant="caption" color="text.secondary" align="center">
//           {t("copyright", { year: new Date().getFullYear() })}
//         </Typography>
//       </Box>

//       {/* Modal for policy details */}
//       {/* <Modal open={modalOpen} onClose={closeModal} aria-labelledby="policy-modal-title" aria-describedby="policy-modal-description">
//         <Box sx={modalStyle}>
//           <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//             <Typography id="policy-modal-title" variant="h6" component="h2" sx={{ textAlign: "center", flexGrow: 1 }}>
//               {modalContent.title}
//             </Typography>
//             <IconButton onClick={closeModal} aria-label="Close modal">
//               <CloseIcon />
//             </IconButton>
//           </Box>
//           <Divider sx={{ mb: 2 }} />
//           <Typography id="policy-modal-description" variant="body2" sx={{ whiteSpace: "pre-line" }}>
//             {modalContent.description}
//           </Typography>
//         </Box>
//       </Modal> */}

//       <Modal open={modalOpen} onClose={closeModal} aria-labelledby="policy-modal-title" aria-describedby="policy-modal-description">
//   <Box sx={{ ...modalStyle, maxHeight: '80vh', overflowY: 'auto' }}>
//     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//       <Typography id="policy-modal-title" variant="h6" component="h2" sx={{ textAlign: "center", flexGrow: 1 }}>
//         {modalContent.title}
//       </Typography>
//       <IconButton onClick={closeModal} aria-label="Close modal">
//         <CloseIcon />
//       </IconButton>
//     </Box>
//     <Divider sx={{ mb: 2 }} />
//     <Typography id="policy-modal-description" variant="body2" sx={{ whiteSpace: "pre-line" }}>
//       {modalContent.description}
//     </Typography>
//   </Box>
// </Modal>

//     </Box>
//   );
// };


import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  IconButton,
  Modal,
  Divider,
  useMediaQuery,
  useTheme,
  Fade,
  Slide,
  Grow,
  Container,
  Paper,
  Button
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import GroupsIcon from '@mui/icons-material/Groups';
import PolicyIcon from '@mui/icons-material/Policy';
import UpdateIcon from '@mui/icons-material/Update';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { useTranslation } from "react-i18next";
import { API_BASE_URL } from "../../config";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95vw", sm: 500, md: 600 },
  maxHeight: "80vh",
  bgcolor: "background.paper",
  background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
  boxShadow: "0 25px 50px rgba(0,0,0,0.25), 0 15px 30px rgba(0,0,0,0.22)",
  p: { xs: 2, sm: 3, md: 4 },
  borderRadius: 4,
  outline: "none",
  border: "1px solid rgba(255,255,255,0.2)",
  backdropFilter: "blur(10px)",
  overflow: "hidden",
};

export const FooterBar = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  // Modal state
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", description: "" });
  const [hoveredPolicy, setHoveredPolicy] = useState(null);

  // Visitors count state
  const [visitorsCount, setVisitorsCount] = useState(null);
  const [countUp, setCountUp] = useState(0);

  // Get policies from translation
  const policies = t("policies", { returnObjects: true });

  // Fetch visitors count from API on component mount
  useEffect(() => {
    const fetchVisitorsCount = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/auth/visitors/`);
        if (response.data && typeof response.data.visitors_count === "number") {
          setVisitorsCount(response.data.visitors_count);
          
          // Animate count up
          let start = 0;
          const end = response.data.visitors_count;
          const duration = 2000; // 2 seconds
          const increment = end / (duration / 16); // 60fps
          
          const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
              setCountUp(end);
              clearInterval(timer);
            } else {
              setCountUp(Math.floor(start));
            }
          }, 16);
        }
      } catch (error) {
        console.error("Failed to fetch visitors count:", error);
      }
    };
    fetchVisitorsCount();
  }, []);

  const openModal = (title, description) => {
    setModalContent({ title, description });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  // Split policies into columns for desktop
  const chunkSize = Math.ceil(policies.length / 3);
  const policyColumns = [];
  for (let i = 0; i < policies.length; i += chunkSize) {
    policyColumns.push(policies.slice(i, i + chunkSize));
  }

  const socialLinks = [
    { icon: <FacebookIcon />, url: "https://www.facebook.com/people/Special-Officer-Competent-Authority/100089782729562/", color: "#1877F2", name: "Facebook" },
    { icon: <TwitterIcon />, url: "https://x.com/Splocakarnataka", color: "#1DA1F2", name: "Twitter" },
    { icon: <LinkedInIcon />, url: "https://linkedin.com", color: "#0A66C2", name: "LinkedIn" },
    { icon: <InstagramIcon />, url: "https://www.instagram.com/sploca_1/", color: "#E4405F", name: "Instagram" },
  ];

  return (
    <Box 
      component="footer" 
      sx={{ 
        width: "100%", 
        background: "linear-gradient(135deg, #589be7ff 0%, #1e3a5f 100%)",
        color: "white",
        mt: 4,
        position: "relative",
        overflow: "hidden",
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4, #ffeaa7)',
          animation: 'rainbow 8s linear infinite',
        }
      }}
    >
      {/* Animated background elements */}
      <Box
        sx={{
          position: 'absolute',
          top: '20%',
          left: '5%',
          width: 100,
          height: 100,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 70%)',
          animation: 'float 15s ease-in-out infinite',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '30%',
          right: '8%',
          width: 80,
          height: 80,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255,255,255,0.03) 0%, transparent 70%)',
          animation: 'float 12s ease-in-out infinite 2s',
        }}
      />

      <Container maxWidth="xl">
        {/* Main Footer Content */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: { xs: 4, md: 3 },
            py: 5,
            position: 'relative',
            zIndex: 1,
          }}
        >
          {/* Disclaimer Section */}
          <Slide direction="up" in={true} timeout={800}>
            <Box sx={{ flex: 1, minWidth: 280, maxWidth: 400 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <PolicyIcon sx={{ color: '#4ecdc4', fontSize: 28 }} />
                <Typography variant="h5" fontWeight="bold" sx={{ color: '#fff' }}>
                  {t("disclaimerTitle")}
                </Typography>
              </Box>
              <Paper
                sx={{
                  p: 2.5,
                  background: 'rgba(255,255,255,0.05)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: 3,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    background: 'rgba(255,255,255,0.08)',
                    transform: 'translateY(-4px)',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
                  }
                }}
              >
                <Typography variant="body1" sx={{ lineHeight: 1.6, color: 'rgba(255,255,255,0.9)' }}>
                  {t("disclaimerText")}
                </Typography>
              </Paper>
            </Box>
          </Slide>

          {/* Website Policies */}
          <Slide direction="up" in={true} timeout={1000}>
            <Box sx={{ flex: 1.5, minWidth: 280 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <GroupsIcon sx={{ color: '#45b7d1', fontSize: 28 }} />
                <Typography variant="h5" fontWeight="bold" sx={{ color: '#fff' }}>
                  {t("websitePolicies")}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" },
                  gap: 1,
                }}
              >
                {policyColumns.map((column, colIndex) => (
                  <Box key={colIndex} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {column.map((policy, index) => (
                      <Grow in={true} timeout={1200 + (colIndex * 200 + index * 100)} key={policy.title}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            p: 1.5,
                            background: hoveredPolicy === policy.title 
                              ? 'rgba(255,255,255,0.15)' 
                              : 'rgba(255,255,255,0.05)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255,255,255,0.1)',
                            borderRadius: 2,
                            cursor: "pointer",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            transform: hoveredPolicy === policy.title ? 'translateX(8px)' : 'translateX(0)',
                            '&:hover': { 
                              background: "rgba(255,255,255,0.2)",
                              transform: "translateX(8px)",
                            },
                          }}
                          onClick={() => openModal(policy.title, policy.description)}
                          onMouseEnter={() => setHoveredPolicy(policy.title)}
                          onMouseLeave={() => setHoveredPolicy(null)}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              openModal(policy.title, policy.description);
                            }
                          }}
                          aria-label={`Open ${policy.title} details`}
                        >
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontWeight: 500,
                              color: 'rgba(255,255,255,0.9)',
                              fontSize: '0.9rem'
                            }}
                          >
                            {policy.title}
                          </Typography>
                          <ChevronRightIcon 
                            fontSize="small" 
                            sx={{ 
                              color: '#96ceb4',
                              transition: 'transform 0.3s ease',
                              transform: hoveredPolicy === policy.title ? 'translateX(4px)' : 'translateX(0)'
                            }} 
                          />
                        </Box>
                      </Grow>
                    ))}
                  </Box>
                ))}
              </Box>
            </Box>
          </Slide>

          {/* Visitors & Social Media */}
          <Slide direction="up" in={true} timeout={1200}>
            <Box sx={{ flex: 1, minWidth: 280 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <UpdateIcon sx={{ color: '#ffeaa7', fontSize: 28 }} />
                <Typography variant="h5" fontWeight="bold" sx={{ color: '#fff' }}>
                  {t("visitors")}
                </Typography>
              </Box>
              
              {/* Visitors Stats */}
              <Paper
                sx={{
                  p: 3,
                  background: 'rgba(255,255,255,0.05)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: 3,
                  mb: 3,
                  textAlign: 'center',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    background: 'rgba(255,255,255,0.08)',
                    transform: 'translateY(-4px)',
                  }
                }}
              >
                <Typography variant="body1" sx={{ mb: 1, color: 'rgba(255,255,255,0.8)' }}>
                  {t("latestUpdate")}
                </Typography>
                <Typography 
                  variant="h4" 
                  fontWeight="bold"
                  sx={{ 
                    color: '#4ecdc4',
                    textShadow: '0 0 20px rgba(78, 205, 196, 0.5)',
                    mb: 1
                  }}
                >
                  {visitorsCount !== null ? countUp.toLocaleString() : "..."}
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                  {t("visitorsCount")}
                </Typography>
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', display: 'block', mt: 1 }}>
                  {t("version")}
                </Typography>
              </Paper>

              {/* Social Media */}
              <Box>
                <Typography variant="h6" sx={{ mb: 2, textAlign: 'center', color: '#fff' }}>
                  Follow Us
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                  {socialLinks.map((social, index) => (
                    <Fade in={true} timeout={1400 + (index * 200)} key={social.name}>
                      <IconButton
                        component="a"
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={social.name}
                        sx={{
                          background: 'rgba(255,255,255,0.1)',
                          backdropFilter: 'blur(10px)',
                          border: '1px solid rgba(255,255,255,0.2)',
                          color: 'white',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            background: social.color,
                            transform: 'translateY(-4px) scale(1.1)',
                            boxShadow: `0 8px 25px ${social.color}40`,
                          }
                        }}
                      >
                        {social.icon}
                      </IconButton>
                    </Fade>
                  ))}
                </Box>
              </Box>
            </Box>
          </Slide>
        </Box>

        {/* Copyright Section */}
        <Fade in={true} timeout={1600}>
          <Box
            sx={{
              py: 3,
              background: 'rgba(0,0,0,0.2)',
              borderTop: '1px solid rgba(255,255,255,0.1)',
              textAlign: 'center',
              position: 'relative',
              backdropFilter: 'blur(10px)',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
              {/* <CopyrightIcon sx={{ fontSize: 16, opacity: 0.7 }} /> */}
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', fontWeight:1000 }}>
                {t("copyright", { year: new Date().getFullYear() })}
              </Typography>
            </Box>
          </Box>
        </Fade>
      </Container>

      {/* Policy Modal */}
      <Modal open={modalOpen} onClose={closeModal} closeAfterTransition>
        <Fade in={modalOpen} timeout={400}>
          <Box sx={modalStyle}>
            <Box sx={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center", 
              mb: 2,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              p: 2,
              borderRadius: 3,
              mx: -3,
              mt: -3,
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: -50,
                right: -50,
                width: 100,
                height: 100,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)',
              }
            }}>
              <Typography 
                id="policy-modal-title" 
                variant="h5" 
                component="h2" 
                sx={{ 
                  textAlign: "center", 
                  flexGrow: 1,
                  fontWeight: 'bold'
                }}
              >
                {modalContent.title}
              </Typography>
              <IconButton 
                onClick={closeModal} 
                aria-label="Close modal"
                sx={{ 
                  color: 'white',
                  background: 'rgba(255,255,255,0.2)',
                  '&:hover': {
                    background: 'rgba(255,255,255,0.3)',
                    transform: 'scale(1.1)'
                  }
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Divider sx={{ mb: 3 }} />
            <Box sx={{ maxHeight: '50vh', overflowY: 'auto', pr: 1 }}>
              <Typography 
                id="policy-modal-description" 
                variant="body1" 
                sx={{ 
                  whiteSpace: "pre-line",
                  lineHeight: 1.7,
                  color: 'text.primary'
                }}
              >
                {modalContent.description}
              </Typography>
            </Box>
            <Box sx={{ mt: 3, textAlign: 'center' }}>
              <Button 
                onClick={closeModal}
                variant="contained"
                sx={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  borderRadius: 2,
                  px: 4,
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)',
                  }
                }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>

      {/* Global styles for animations */}
      <style jsx global>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        
        @keyframes rainbow {
          0% { background-position: 0% 50%; }
          100% { background-position: 100% 50%; }
        }
      `}</style>
    </Box>
  );
};